import type { ArticleDrillBatchContent } from "../content-types";
import { Explanation, Prompt } from "./shared";
import { PickButtons } from "./drill-helpers";
import type { QuestionRendererProps } from "./types";

/** Per-noun article drill (mirrors iOS ArticleDrillBatchView: pick the correct
 *  article per noun; exact match). */
export function ArticleDrillBatchRenderer({ content, answer, setAnswer, revealed }: QuestionRendererProps) {
  const c = content as unknown as ArticleDrillBatchContent;
  const items = c.items ?? [];
  const map = (answer as Record<string, string>) ?? {};
  return (
    <div>
      <Prompt>{c.prompt}</Prompt>
      {c.case_label && <p className="mt-1 text-sm text-ink-faint">{c.case_label}</p>}
      <div className="mt-4 space-y-3">
        {items.map((it) => (
          <div key={it.id} className="rounded-xl bg-slate-50 p-3">
            <div className="mb-2 text-sm font-semibold text-ink">
              ___ {it.noun}
              {it.hint && <span className="ml-2 text-xs text-ink-faint">({it.hint})</span>}
            </div>
            <PickButtons
              options={c.articles ?? []}
              chosen={map[it.id]}
              correct={it.correct_article}
              revealed={revealed}
              onPick={(v) => setAnswer({ ...map, [it.id]: v })}
            />
          </div>
        ))}
      </div>
      {revealed && <Explanation text={c.explanation} />}
    </div>
  );
}
